import { jsx as _jsx } from "react/jsx-runtime";
import validator from '@rjsf/validator-ajv8';
import { observer } from 'mobx-react-lite';
import { Box } from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import { RegistryFields } from './JsForm.components';
import s from './JsForm.module.css';
const JsFormFC = ({ schema, formData, uiSchema, onChange }) => {
    return (_jsx(Box, { className: s.form, children: _jsx(Form
        // eslint-disable-next-line react/no-children-prop
        , { 
            // eslint-disable-next-line react/no-children-prop
            children: true, liveValidate: true, validator: validator, showErrorList: false, liveOmit: false, omitExtraData: false, schema: schema, formData: formData, uiSchema: uiSchema, fields: RegistryFields, onChange: async (data, id) => {
                await onChange(data.formData, id);
            }, onError: (errors) => console.error('JsForm error:', errors), className: 'js-form' }) }));
};
export const JsForm = observer(JsFormFC);
//# sourceMappingURL=JsForm.js.map